import React from "react";

/** Montserrat Regular 14–16pt, max 60 characters/line, navy. Left-aligned. */
const Body = ({ children, className = "", as: Tag = "p" }) => {
  return (
    <Tag
      className={`brand-body font-body font-regular text-body text-ink text-left max-w-prose ${className}`}
    >
      {children}
    </Tag>
  );
};

export default Body;
